module.exports = __webpack_public_path__ + "static/media/01.e6299b29.jpg";